import { useHasProjectSettingsPermissions } from '@monorepo/shared/hooks/permissions/useHasPermissions';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Page } from '../styled';
import { SiteDocumentsHeader } from './SiteDocumentsHeader';
import { SiteDocumentsTable } from './SiteDocumentsTable';

export function SiteDocumentsPage() {
  const { organizationId, projectId } = useParams();
  if (!organizationId || !projectId) {
    throw new Error(
      "SiteDocuments page was rendered with a url that doesn't have organizationId or projectId",
    );
  }

  const [filter, setFilter] = useState('');
  const canEditSiteDocuments = useHasProjectSettingsPermissions(projectId);

  return (
    <Page>
      <SiteDocumentsHeader
        organizationId={organizationId}
        projectId={projectId}
        filter={filter}
        onSearch={setFilter}
        canEditSiteDocuments={canEditSiteDocuments}
      />
      <SiteDocumentsTable
        organizationId={organizationId}
        projectId={projectId}
        filter={filter}
        canEditSiteDocuments={canEditSiteDocuments}
      />
    </Page>
  );
}
